import templateUrl from '../../../views/workflows/send-single-sms.tpl.html'

/**
 * @ngdoc service
 * @name checkins.factory:smsRsvp
 *
 * @description
 *
 */

class singleSmsCtrl {
    constructor($uibModalInstance, $scope, $injector, rsvp) {
        this.modalInstance = $uibModalInstance;
        this.scope = $scope;
        this.injector = $injector;
        this.rsvp = rsvp;
        this.alert = this.injector.get('Alert');
        this.api = this.injector.get('$http');

        this.sender_names = _.get($injector.get('Users').state.loggedin.profile.company.data, 'settings.messages.sms_sender_names', []);

        this.selectedSmsTemplateId = null
        this.selectedSmsTemplate = null;

        this.smsTemplateSelectConfig =  {
            store: this.injector.get('SmsTemplates').reset({
                persist: false,
                listview: 'SendSmsTemplatesSelect'
            }),
            valueField: 'id',
            displayField: 'name',
            maxItems: 1
        };

        this.message = {
            type: 'sms',
            send_to_override: this.rsvp.contact.data.preferred_phone_2,
            recipient_type: 'rsvp',
            sender_name: this.sender_names[0] ? this.sender_names[0].value : null,
            rsvps: {
                filters: [
                    {
                        field: 'id',
                        operator: 'IN',
                        value: [rsvp.id]
                    }
                ],
                count: 1
            },
            content:'',
            attach_ticket: true,
            attach_passbook: true,
            attach_files: true,
            attach_invoice: true
        };
        this.setSendToOptions();

        this.messageValidation = {
            isGsm: true,
            limit: 140,
            length: 0,
            smsCount: 0
        };

        this.aceOptions = {};
        $injector.get('AceEditor').getEditor((editor) => this.aceOptions = editor);

        this.scope.$watch(()=> this.message.content, () => {
            let gsm = "@£$¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞ^{}\[~]|€ÆæßÉ!\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà\n ",
                gsmDoubleBytes = '€~{}[]^|\\',
                gsmCheck = true,
                strLengthPerChar = 0,
                strLengthGsm = 0;

            for (let i = 0, n = this.message.content.length; i < n; i++) {
                strLengthPerChar++;
                strLengthGsm++;
                let curChar = this.message.content[i];
                if (gsm.indexOf(curChar) !== -1) {
                    if (gsmDoubleBytes.indexOf(curChar) !== -1) {
                        strLengthGsm++;
                    }
                } else {
                    gsmCheck = false;
                }
            }

            if (gsmCheck) {
                this.messageValidation = {
                    isGsm: true,
                    limit: 140,
                    length: strLengthGsm,
                    smsCount: (strLengthGsm > 0) ? Math.ceil(strLengthGsm / 140) : 0
                };
            } else {
                this.messageValidation = {
                    isGsm: false,
                    limit: 70,
                    length: strLengthPerChar,
                    smsCount: (strLengthPerChar > 0) ? Math.ceil(strLengthPerChar / 70) : 0
                };
            }
        });

        this.scope.$watch(() => this.selectedSmsTemplateId, () => {
            if(!this.selectedSmsTemplateId) {
                this.selectedSmsTemplate = null
                return
            }

            this.api.get(`messages/sms/templates/${this.selectedSmsTemplateId}`)
                .then((response) => {
                    this.selectedSmsTemplate = response.data.data

                    this.message.content = this.selectedSmsTemplate.content;
                    this.message.sender_name = this.selectedSmsTemplate.from_number;
                })
        })
    }

    close() {
        this.modalInstance.dismiss();
    }

    setSendToOptions() {
        this.numbers = {};
        if (this.rsvp.contact.data.phone_2) {
            this.numbers.private = this.rsvp.contact.data.phone_2
        }
        if (this.rsvp.business_phone_2) {
            this.numbers.business = this.rsvp.contact.data.business_phone_2
        }
        this.numbers.custom = '';
        this.send_to_override = this.rsvp.contact.data.business_preferred ? 'business' : 'private';
    }

    send(form) {
        if (form.$valid && this.message.content.length) {
            this.sending = true;
            return this.api.post(`messages`, this.message)
                .then(() => {
                    this.alert.success('Message Sent', 'Your message has been queued for sending');
                    this.close();
                }, response => {
                    this.alert.handle(response);
                })
                .finally(() => {
                    this.sending = false;
                });
        }
    }
}


function smsRsvp(Alert, $uibModal) {
    return {
        key: 'sms-rsvp',
        title: 'Send SMS',
        icon: 'sms',
        order: 40,
        level: 'highlight',
        action(rsvp) {
            $uibModal.open({
                templateUrl,
                controller: ['$uibModalInstance', '$scope', '$injector', 'rsvp', singleSmsCtrl],
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    rsvp() {
                        return rsvp;
                    }
                }
            })
                .result.then(null, err => Alert.handle(err));
        }
    }
}

angular
    .module('festzelt-os.guestlists')
    .factory('smsRsvp', [
        'Alert',
        '$uibModal',
        smsRsvp
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/detailed/sms-rsvp.js